"use client"
import { ConfigProvider, Menu, MenuProps } from 'antd';
import { MenuItem } from '../../config/nav-items.config';
import { useState } from 'react';
import { useNavigate } from 'react-router';
interface SidebarProps {
    selectedKeys: string[],
    items: MenuItem[],
    collapsed: boolean
}

const Sidebar: React.FC<SidebarProps> = ({selectedKeys, items, collapsed}) => {
    const [openKeys, setOpenKeys] = useState<string[]>(selectedKeys);
    const navigate = useNavigate();
    const onClick: MenuProps['onClick'] = (e) => {
        navigate("/"+e.keyPath.reverse().join("/"));
    };
    const onOpenChange = (openKeys: string[]) => {
        setOpenKeys([openKeys[openKeys.length-1]]);
    }
    return (<div className='bg-white border-r border-gray-300 label-primary select-none bshadow z-10'>
        <ConfigProvider theme={
                {
                    components: {
                        Menu: {
                            iconMarginInlineEnd: 4,
                            itemPaddingInline: 20,
                            itemSelectedBg: 'rgba(0, 68, 102, 0.8)',
                            itemActiveBg: '#E8F1F6',
                            itemHoverBg: '#E8F1F6',
                            itemBorderRadius: 0,
                            itemMarginInline: 0,
                            itemMarginBlock: 0,
                            itemHeight: 64,
                            itemSelectedColor: "rgba(0, 68, 102, 0.8)",
                        }
                    },
                    token: {
                        fontSize: 16,
                    },
                }
            }>
            <Menu
                onClick={onClick}
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                mode="inline"
                items={items}
                onOpenChange={onOpenChange}
                style={{width: collapsed?80:300}}
                inlineCollapsed={collapsed}
            />
        </ConfigProvider>

      </div>)
}

export default Sidebar;